import { useEffect, useState } from 'react';

import { inventory, type InventoryRowDTO } from '@/api/endpoints';
import { ItemGrid } from './ItemGrid';

export function Book() {
  const [data, setData] = useState<Awaited<ReturnType<typeof inventory.collection>> | null>(null);
  const [pool, setPool] = useState<'trash' | 'treasure'>('trash');

  useEffect(() => { void inventory.collection().then(setData); }, []);

  if (!data) return <p className="py-6 text-center text-[11px] text-ink-dim">Loading…</p>;

  const shown: InventoryRowDTO[] = data.items.filter((i) => i.pool === pool);
  const found = pool === 'trash' ? data.trash_found : data.treasure_found;
  const total = pool === 'trash' ? data.trash_total : data.treasure_total;

  return (
    <div className="h-full overflow-y-auto px-3 pb-6 pt-3.5">
      <h2 className="font-pixel text-[9px] text-torch-core">MINING LOG</h2>
      <div className="mt-2.5 grid grid-cols-2 gap-1.5">
        <Stat k="Trash found" v={`${data.trash_found} / ${data.trash_total}`} />
        <Stat k="Treasure found" v={`${data.treasure_found} / ${data.treasure_total}`} />
      </div>

      <div className="mt-2.5">
        <div className="flex items-center justify-between text-[11px]">
          <span className="text-ink-dim">Completion</span>
          <b className="tabular text-ink-hi">{data.completion_pct}%</b>
        </div>
        <span className="mt-1 block h-2 overflow-hidden rounded-full bg-white/10">
          <i className="block h-full rounded-full bg-[linear-gradient(90deg,#F5A02A,#FFD36E)]"
             style={{ width: `${data.completion_pct}%` }} />
        </span>
      </div>

      <div className="mt-3 flex gap-1.5">
        {(['trash', 'treasure'] as const).map((p) => (
          <button key={p} type="button" onClick={() => setPool(p)}
            className={`flex-1 rounded-lg border py-2 font-pixel text-[8px] uppercase ${
              pool === p ? 'border-coin bg-[linear-gradient(#F5D06A,#D0A420)] text-[#101010]'
                         : 'border-[var(--hairline)] bg-black/30 text-ink-dim'}`}>
            {p} ({found}/{total})
          </button>
        ))}
      </div>

      <div className="mt-2.5">
        <ItemGrid items={shown} empty="Nothing discovered yet." showLocked />
      </div>
    </div>
  );
}

function Stat({ k, v }: { k: string; v: string }) {
  return (
    <div className="flex items-baseline justify-between gap-1.5 rounded-lg bg-black/30 px-2.5 py-2 text-[11px]">
      <span className="text-ink-dim">{k}</span><b className="tabular text-ink-hi">{v}</b>
    </div>
  );
}
